var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPaperPlane = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5559 2.28138L1.6434 12.8376C1.59428 12.9265 1.5734 13.0283 1.58356 13.1294C1.59372 13.2305 1.63442 13.3261 1.70025 13.4034C1.76608 13.4808 1.85392 13.5363 1.95207 13.5625C2.05021 13.5887 2.15401 13.5844 2.24965 13.5501L7.82465 11.5626C7.93289 11.5188 8.05391 11.5188 8.16215 11.5626L13.7372 13.5501C13.8328 13.5844 13.9366 13.5887 14.0347 13.5625C14.1329 13.5363 14.2207 13.4808 14.2866 13.4034C14.3524 13.3261 14.3931 13.2305 14.4032 13.1294C14.4134 13.0283 14.3925 12.9265 14.3434 12.8376L8.4309 2.28138C8.38766 2.20323 8.32428 2.13808 8.24734 2.09272C8.1704 2.04736 8.08272 2.02344 7.9934 2.02344C7.90409 2.02344 7.8164 2.04736 7.73946 2.09272C7.66252 2.13808 7.59914 2.20323 7.5559 2.28138Z",
    stroke: "#3030AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99316 11.5V7.5",
    stroke: "#3030AD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPaperPlane);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/paperPlane.07af3c989f71ced63db76fe7786eea50.svg";